import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, watch } from 'vue';
import type { PropType } from 'vue';
import type { FormField } from '@/types/form';
import { remoteOptionsRegistry } from '@/lib/remoteOptions';


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupedFieldsExpansionPanel',
  props: {
  fields: Array as PropType<FormField[]>,
  modelValue: Object as PropType<Record<string, any>>,
  label: { type: String, default: 'Grupo de Campos' },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Agrega mapeo inicial de valores planos a objetos
onMounted(async () => {
  for (const field of props.fields || []) {
    if (field.fetchOptions && remoteOptionsRegistry[field.fetchOptions]) {
      const fetchFn = remoteOptionsRegistry[field.fetchOptions];
      const options = await fetchFn('');
      field.options = options;

      const val = props.modelValue?.[field.value];
      const itemValueKey = field.itemValue || 'value';

      if (val && typeof val !== 'object') {
        const match = options.find(opt => opt[itemValueKey] === val);
        if (match) {
          emit('update:modelValue', {
            ...props.modelValue,
            [field.value]: match,
          });
        }
      }
    }
  }
});

const getFieldProps = (field: FormField) => {
  const props: Record<string, any> = {
    label: field.label,
    placeholder: field.placeholder ?? '',
    clearable: true,
    density: 'compact',
    type: field.type || 'text',
    prefix: field.prefix,
    suffix: field.suffix,
    'prepend-inner-icon': field.icon,
    disabled: field.permission === 'disabled',
    readonly: field.readonly,
    'item-title': field.itemText || 'label',
    'item-value': field.itemValue || 'value',
  };

  if (field.options) {
    props.items = field.options;
  }

  if (field.fetchOptions && remoteOptionsRegistry[field.fetchOptions]) {
    props['onUpdate:search'] = async (val: string) => {
      if (!val || val.length < 2) return;
      const fetchFn = remoteOptionsRegistry[field.fetchOptions!];
      const results = await fetchFn(val);
      field.options = results;
      props.items = results;
    };
  }

  return props;
};

return (_ctx: any,_cache: any) => {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createBlock(_component_v_expansion_panels, { elevation: "0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_expansion_panel, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_expansion_panel_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.label), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: field.value,
                      cols: `${field.col || 12}`
                    }, {
                      default: _withCtx(() => [
                        (!field.children)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(field.component), _mergeProps({
                              key: 0,
                              "model-value": __props.modelValue?.[field.value] ?? null,
                              "onUpdate:modelValue": val =>
                emit('update:modelValue', {
                  ...__props.modelValue,
                  [field.value]: val
                }),
                              ref_for: true
                            }, getFieldProps(field), {
                              rules: field.required ? [v => !!v || 'Campo obligatorio'] : []
                            }), null, 16, ["model-value", "onUpdate:modelValue", "rules"]))
                          : (_openBlock(), _createBlock(_resolveDynamicComponent(field.component), {
                              key: 1,
                              modelValue: __props.modelValue[field.value],
                              "onUpdate:modelValue": ($event: any) => ((__props.modelValue[field.value]) = $event),
                              fields: field.children,
                              summary: field.summary,
                              label: field.label
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "fields", "summary", "label"]))
                      ]),
                      _: 2
                    }, 1032, ["cols"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})